import * as DialogPrimitive from "@radix-ui/react-dialog";
import type { ComponentProps } from "react";

export type DialogCloseProps = ComponentProps<typeof DialogPrimitive.Close>;

export const DialogClose = (props: DialogCloseProps) => <DialogPrimitive.Close data-slot="dialog-close" {...props} />;
